import { gql } from '@apollo/client'

export const Query = gql`
  query Warehouses($companyId: ID!, $filters: WarehouseFilters, $order: WarehouseOrder, $after: String, $before: String, $first: Int, $last: Int) {
    warehouses(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        address
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
